import React, { Ref, useEffect, useState } from 'react';
import HTMLFlipBook from 'react-pageflip';
import LogoBlack from '../../Admin/logoBlack.png';
import Logo from '../../Admin/logo.webp';
import { getCurrentYear } from '../../../helper/helper';
import { StoryAgeGroupTypeEnum } from '../../../interfaces/book.interface';
import FlipBookShare from './BookFlipShare';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useStorageObjectUrl } from '../../../services/file.service';

type BookFlipPreviewPageImageProps = {
  imageURL: string;
};

export const BookFlipPreviewPageImage: React.FC<BookFlipPreviewPageImageProps> = ({ imageURL }) => {
  const { url, loading, error } = useStorageObjectUrl(imageURL);

  const bg = url || imageURL || '/pattern.png';

  return (
    <div
      style={{
        backgroundImage: `url('${bg}')`,
        backgroundSize: 'contain',
        height: '100%',
        width: '100%',
      }}
    />
  );
};

interface PageProps {
  children: React.ReactNode;
  className: string;
  style?: React.CSSProperties;
}

const Page = React.forwardRef(({ children, className, style }: PageProps, ref: Ref<HTMLDivElement> | undefined) => (
  <div className={`page ${className}`} ref={ref} style={style}>
    {children}
  </div>
));

interface BookPreviewProps {
  bookData: any;
  bookIdAdmin: any;
  flipBookRef: any;
  sortedPages: any;
  user: any;
  isShare: boolean;
  totalPages: number;
}

const BookPreview: React.FC<any> = ({ bookData, bookIdAdmin, flipBookRef, sortedPages, user, isShare, totalPages }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [currentPageIndex, setCurrentPageIndex] = useState<number>(0);
  const [fullBook, setFullBook] = useState<boolean>(false);
  const lastPage = totalPages + 5;

  const { url: coverImageURL } = useStorageObjectUrl(bookData?.coverURL);

  const [containerSize, setContainerSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setContainerSize({ width: window.innerWidth, height: window.innerHeight });
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="relative">
      <HTMLFlipBook
        width={bookIdAdmin ? (isMobile ? 300 : 500) : isMobile ? 310 : 600}
        height={bookIdAdmin ? (isMobile ? 300 : 500) : isMobile ? 310 : 600}
        className="mx-auto overflow-hidden flex items-center justify-center"
        startPage={isMobile ? 1 : 0}
        ref={flipBookRef}
        style={{}}
        onFlip={(event) => {}}
        onChangeState={(event) => {
          if (event.data === 'read') {
            setFullBook(event.object?.pages?.currentPageIndex !== event.object?.pages?.currentSpreadIndex);
            setCurrentPageIndex(event.object?.pages?.currentPageIndex);
          }
        }}
        {...({} as any)}
      >
        <Page key="front-blank" className="cover-page ">
          <div className=" mx-4 mr-4 flex justify-center items-center h-full">
            {/*<h1 className="text-xl md:text-2xl w-[20rem] md:w-[25rem] font-bold text-center">*/}
            {/*  Enjoy flipping through the pages of your personal story.*/}
            {/*</h1>*/}
          </div>
        </Page>
        <Page key="cover" className="cover-page bg-storyblue shadow-2xl">
          <div className="h-full w-full flex justify-center items-center relative">
            <div
              className="absolute h-full w-full grayscale rounded"
              style={{
                backgroundImage: `url('${coverImageURL || bookData?.coverURL || '/pattern.png'}')`,
                backgroundSize: 'cover',
                height: '100%',
                width: '100%',
              }}
            ></div>
            <div
              className="h-[300px] md:h-[540px] w-[250px] md:w-[450px] rounded flex justify-center pt-[15px] md:pt-[25px]"
              style={{
                backgroundImage: `url('${'/texture.png'}')`,
                backgroundSize: 'cover',
                zIndex: 1,
              }}
            >
              <div
                className="h-[200px] md:h-[400px] w-[200px] md:w-[400px] rounded flex justify-center items-center relative"
                style={{
                  backgroundImage: `url('${coverImageURL || bookData?.coverURL || '/pattern.png'}')`,
                  backgroundSize: window.innerWidth < 768 ? '300px' : '600px',
                  backgroundPosition: '50% 27.5%',
                }}
              >
                <div className="relative flex flex-col items-center gap-2 top-[8.5rem] md:top-[16rem]">
                  <h1 className="text-lg md:text-3xl text-center font-yuji-boku">{bookData?.title}</h1>
                  <h1 className="font-poppins text-sm md:text-md capitalize text-gray-600">
                    by {bookData?.authorName || bookData?.author}
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </Page>

        <Page key="copyright" className="cover-page bg-storyblue">
          <div
            className="h-[100%] flex flex-col  mx-auto py-3 bg-gray-200"
            style={{
              backgroundImage: `url("/paper.jpg")`,
              backgroundSize: 'cover',
            }}
          >
            <div className="flex flex-col justify-center items-center p-4 md:p-8 gap-4 md:gap-28">
              <h3 className="text-xl md:text-4xl bold font-yuji-boku">{bookData?.title}</h3>
              <h3 className="text-[.75rem] md:text-xl text-justify text-black">
                <p className="font-poppins mb-2 md:mb-4">
                  All rights reserved. No part of the publication may be reproduced, stored in or introduced into a
                  retrieval system, or trasmitted, in any form, or by any means (electronic, mechanica, photocopying,
                  recording or otherwise) without the prior written permission of the author.
                </p>
                <p className="  font-poppins">
                  Any person who does any unauthorized act in relation to this publication may be liable to criminal
                  prosecution ad civil claims for damages. Text and illustrations copyright &#169; {user?.firstName}{' '}
                  {user?.lastName} {getCurrentYear()} Moral rights asserted.
                </p>
              </h3>
            </div>
            <div className="w-full flex flex-col   items-center gap-1">
              <div className="flex items-baseline gap-1">
                <img className="h-3 md:h-6 w-auto" src={LogoBlack} alt="Build My Story" />
              </div>
            </div>
          </div>
        </Page>
        <Page key="branding" className=" text-page h-screen">
          <div
            className="flex flex-col justify-end pb-4 gap-1 items-center  font-serif"
            style={{
              backgroundImage: `url("/paper.jpg")`,
              backgroundSize: 'cover',
              height: '100%',
              width: '100%',
            }}
          >
            {/* //branding */}
            <div
              style={{
                height: '100%',
                width: '100%',
                backgroundImage: `url('paper.jpg')`,
                backgroundSize: 'cover',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img src={Logo} alt="logo" className="h-12 md:h-16 w-auto mx-auto" />
            </div>
          </div>
        </Page>

        {sortedPages()?.flatMap(([pageKey, pageDetails]: [string, any], index: number) => [
          <Page key={`${pageKey}-text`} className="bg-storytan text-page h-screen">
            <div
              style={{
                backgroundImage: `url("/paper.jpg")`,
                backgroundSize: 'cover',
                height: '100%',
                width: '100%',
              }}
            >
              <h3
                className={`leading-normal px-8 h-full flex items-center font-bold text-justify font-poppins ${
                  bookData?.childAge === StoryAgeGroupTypeEnum.AGE_0_2
                    ? 'text-xl md:text-2xl'
                    : bookData?.childAge === StoryAgeGroupTypeEnum.AGE_3_7
                      ? 'text-lg md:text-xl'
                      : bookData?.childAge === StoryAgeGroupTypeEnum.AGE_8_12
                        ? 'text-base md:text-lg'
                        : 'text-xs md:text-sm'
                }`}
              >
                {pageDetails.text}
              </h3>
            </div>
            <div className="page-number mt-[-30px] w-full flex justify-center">
              <div
                className=" text-base w-12 h-6 flex justify-center items-center font-bold text-storyblue "
                style={{ fontFamily: 'system-ui' }}
              >
                {index * 2 + 5}
              </div>
            </div>
          </Page>,
          <Page key={`${pageKey}-image`} className="image-page">
            <BookFlipPreviewPageImage
              imageURL={pageDetails?.imageURLwebp || pageDetails?.imageURL}
            ></BookFlipPreviewPageImage>
            <div className="page-number mt-[-30px] w-full flex justify-center">
              <div
                className=" w-12 h-6 mb-2 flex justify-center items-center rounded-full font-bold text-base text-white"
                style={{
                  fontFamily: 'system-ui',
                  position: 'absolute',
                  bottom: '0',
                  left: '50%',
                  transform: 'translateX(-50%)',
                }}
              >
                {/* {index * 2 + 6}/{bookData?.pageTotal} */}
                {index * 2 + 6}
              </div>
            </div>
          </Page>,
        ])}

        {/*First Blank Page-dino page */}
        <Page key="back-pattern" className="cover-page ">
          <div
            style={{
              backgroundImage: `url("/pattern.png")`,
              backgroundSize: 'cover',
              height: '100%',
              width: '100%',
            }}
          ></div>
        </Page>
        {/* Second Blank Page */}
        {isShare ? (
          <Page key="back-blank-share" className="cover-page bg-storyblue">
            <div
              style={{
                backgroundImage: `url("/paper.jpg")`,
                backgroundSize: 'cover',
                height: '100%',
                width: '100%',
              }}
            ></div>
          </Page>
        ) : (
          <Page key="back-blank" className=" text-page h-screen">
            <div className="flex justify-center items-center h-full"></div>
          </Page>
        )}
        {/* Last Cover Page */}
        <Page key="back-cover" className=" text-page h-screen">
          <div
            className="flex flex-col justify-between py-4 md:py-12 px-8 items-center  font-serif"
            style={{
              backgroundImage: `url("/paper.jpg")`,
              backgroundSize: 'cover',
              height: '100%',
              width: '100%',
            }}
          >
            <div className="flex flex-col  gap-4 md:gap-14">
              <h3 className="text-xl md:text-2xl font-yuji-boku">{bookData?.title}</h3>
              <h3 className="text-sm md:text-base font-poppins">{bookData?.summary}</h3>
            </div>
            <div className="w-full flex flex-col justify-center items-center gap-2">
              <img className="h-6 md:h-10 w-auto" src={LogoBlack} alt="Build My Story" />
              <h3>www.buildmystory.com</h3>
            </div>
          </div>
        </Page>
      </HTMLFlipBook>
      {/* Left/Right navigation buttons */}
      <button
        type="button"
        className={`absolute top-1/2 left-2 transform -translate-y-1/2 ${currentPageIndex === 0 ? 'hidden' : ''}
                   rounded-full px-3 py-2 bg-storyblueSecondLightText hover:bg-storyblueSecondLightTextBold text-white shadow md:-ml-5`}
        onClick={() => {
          flipBookRef.current?.pageFlip().flipPrev();
        }}
      >
        <FontAwesomeIcon icon={faArrowLeft} title="Status" />
      </button>

      <button
        type="button"
        className={`absolute top-1/2 right-2 transform -translate-y-1/2 ${lastPage === currentPageIndex ? 'hidden' : ''}
                   rounded-full px-3 py-2 bg-storyblueSecondLightText hover:bg-storyblueSecondLightTextBold text-white shadow md:-mr-5`}
        onClick={() => {
          flipBookRef.current?.pageFlip().flipNext();
        }}
      >
        <FontAwesomeIcon icon={faArrowRight} title="Status" />
      </button>

      {!isShare &&
        ((lastPage - 2 === currentPageIndex && fullBook) || (lastPage === currentPageIndex - 3 && !fullBook)) && (
          <div
            className={`absolute top-0 ${!fullBook ? 'left-0 right-0 w-[100%]' : 'left-[50%] right-6'}`}
            style={{ marginTop: isMobile ? '0' : '180px' }}
          >
            <div className="text-center justify-self-center flex flex-col">
              <h2 className="text-left text-2xl md:text-2xl mb-4 font-bold text-storyblue main-title-modal-text">
                Share this story with your friends
              </h2>
              <FlipBookShare bookData={bookData} isInline={true}></FlipBookShare>
            </div>
          </div>
        )}
    </div>
  );
};

export default BookPreview;
